module.exports = __webpack_public_path__ + "static/img/1.0c53da9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/zh/1.png
// module id = 7rTf
// module chunks = 0